import { render, staticRenderFns } from "./MappingsTable.vue?vue&type=template&id=0512a5c6&scoped=true"
import script from "./MappingsTable.vue?vue&type=script&lang=js"
export * from "./MappingsTable.vue?vue&type=script&lang=js"
import style0 from "./MappingsTable.vue?vue&type=style&index=0&id=0512a5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0512a5c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/.pnpm/vuetify-loader@1.7.3_uhb5aaqqgawn4pxsnzso5z623i/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VDataTable,VDivider,VIcon,VSpacer,VToolbar,VToolbarTitle})
